import { nsTerminal } from '@/app/i18n/namespaces';

const AUTHORIZATION_CODE = {
    EMPTY: { name: 'EMPTY', entity: 'authorization_code.EMPTY', namespace: nsTerminal },
    '02': { name: '02', entity: 'authorization_code.02', namespace: nsTerminal },
    '03': { name: '03', entity: 'authorization_code.03', namespace: nsTerminal },
    '04': { name: '04', entity: 'authorization_code.04', namespace: nsTerminal },
    '05': { name: '05', entity: 'authorization_code.05', namespace: nsTerminal },
    '07': { name: '07', entity: 'authorization_code.07', namespace: nsTerminal },
    '08': { name: '08', entity: 'authorization_code.08', namespace: nsTerminal },
    10: { name: '10', entity: 'authorization_code.10', namespace: nsTerminal },
    12: { name: '12', entity: 'authorization_code.12', namespace: nsTerminal },
    13: { name: '13', entity: 'authorization_code.13', namespace: nsTerminal },
    14: { name: '14', entity: 'authorization_code.14', namespace: nsTerminal },
    15: { name: '15', entity: 'authorization_code.15', namespace: nsTerminal },
    17: { name: '17', entity: 'authorization_code.17', namespace: nsTerminal },
    19: { name: '19', entity: 'authorization_code.19', namespace: nsTerminal },
    20: { name: '20', entity: 'authorization_code.20', namespace: nsTerminal },
    21: { name: '21', entity: 'authorization_code.21', namespace: nsTerminal },
    24: { name: '24', entity: 'authorization_code.24', namespace: nsTerminal },
    25: { name: '25', entity: 'authorization_code.25', namespace: nsTerminal },
    26: { name: '26', entity: 'authorization_code.26', namespace: nsTerminal },
    27: { name: '27', entity: 'authorization_code.27', namespace: nsTerminal },
    28: { name: '28', entity: 'authorization_code.28', namespace: nsTerminal },
    29: { name: '29', entity: 'authorization_code.29', namespace: nsTerminal },
    30: { name: '30', entity: 'authorization_code.30', namespace: nsTerminal },
    31: { name: '31', entity: 'authorization_code.31', namespace: nsTerminal },
    32: { name: '32', entity: 'authorization_code.32', namespace: nsTerminal },
    33: { name: '33', entity: 'authorization_code.33', namespace: nsTerminal },
    34: { name: '34', entity: 'authorization_code.34', namespace: nsTerminal },
    38: { name: '38', entity: 'authorization_code.38', namespace: nsTerminal },
    41: { name: '41', entity: 'authorization_code.41', namespace: nsTerminal },
    43: { name: '43', entity: 'authorization_code.43', namespace: nsTerminal },
    51: { name: '51', entity: 'authorization_code.51', namespace: nsTerminal },
    54: { name: '54', entity: 'authorization_code.54', namespace: nsTerminal },
    55: { name: '55', entity: 'authorization_code.55', namespace: nsTerminal },
    56: { name: '56', entity: 'authorization_code.56', namespace: nsTerminal },
    57: { name: '57', entity: 'authorization_code.57', namespace: nsTerminal },
    58: { name: '58', entity: 'authorization_code.58', namespace: nsTerminal },
    59: { name: '59', entity: 'authorization_code.59', namespace: nsTerminal },
    60: { name: '60', entity: 'authorization_code.60', namespace: nsTerminal },
    61: { name: '61', entity: 'authorization_code.61', namespace: nsTerminal },
    63: { name: '63', entity: 'authorization_code.63', namespace: nsTerminal },
    68: { name: '68', entity: 'authorization_code.68', namespace: nsTerminal },
    75: { name: '75', entity: 'authorization_code.75', namespace: nsTerminal },
    76: { name: '76', entity: 'authorization_code.76', namespace: nsTerminal },
    90: { name: '90', entity: 'authorization_code.90', namespace: nsTerminal },
    91: { name: '91', entity: 'authorization_code.91', namespace: nsTerminal },
    94: { name: '94', entity: 'authorization_code.94', namespace: nsTerminal },
    96: { name: '96', entity: 'authorization_code.96', namespace: nsTerminal },
    97: { name: '97', entity: 'authorization_code.97', namespace: nsTerminal },
    98: { name: '98', entity: 'authorization_code.98', namespace: nsTerminal },
    99: { name: '99', entity: 'authorization_code.99', namespace: nsTerminal },

    NR: { name: 'NR', entity: 'authorization_code.NR', namespace: nsTerminal },
    '00': { name: '00', entity: 'authorization_code.00', namespace: nsTerminal },
    46: { name: '46', entity: 'authorization_code.46', namespace: nsTerminal },
    62: { name: '62', entity: 'authorization_code.62', namespace: nsTerminal },
    '6P': { name: '6P', entity: 'authorization_code.6P', namespace: nsTerminal },
    77: { name: '77', entity: 'authorization_code.77', namespace: nsTerminal },
    78: { name: '78', entity: 'authorization_code.78', namespace: nsTerminal },
    93: { name: '93', entity: 'authorization_code.93', namespace: nsTerminal },
    A0: { name: 'A0', entity: 'authorization_code.A0', namespace: nsTerminal },
    A1: { name: 'A1', entity: 'authorization_code.A1', namespace: nsTerminal },
    A2: { name: 'A2', entity: 'authorization_code.A2', namespace: nsTerminal },
    A3: { name: 'A3', entity: 'authorization_code.A3', namespace: nsTerminal },
    A4: { name: 'A4', entity: 'authorization_code.A4', namespace: nsTerminal },
    R0: { name: 'R0', entity: 'authorization_code.R0', namespace: nsTerminal },
    R1: { name: 'R1', entity: 'authorization_code.R1', namespace: nsTerminal },
    R3: { name: 'R3', entity: 'authorization_code.R3', namespace: nsTerminal }

};

export default AUTHORIZATION_CODE;